import { fetchJson } from './api_helpers';
import { API_BASE_URL } from '../constants';

/**
 * Get entity detail payload from the unified endpoint (fields used by EntityFrame).
 * @param {number|string} entityId - The entity ID to fetch
 * @param {AbortSignal} signal - Optional AbortController signal for cancellation
 * @returns {Promise<{ entity: Object, tags: Object|null }>}
 */
export const getAllEntityData = async (entityId, signal = null) => {
  try {
    const url = `${API_BASE_URL}/awatch/${entityId}`;
    const fetchOptions = signal ? { signal } : {};
    const responseData = await fetchJson(url, fetchOptions);

    if (signal?.aborted) {
      throw new DOMException('Request aborted', 'AbortError');
    }
    const data = responseData.entity;

    if (!data) {
      throw new Error('Entity data not found in response');
    }

    const entity = {
      EntityId: data.EntityId,
      DisplayName: data.DisplayName,
      Description: data.Description,
      Subtitle: data.Subtitle,
      Text: data.Text,
      CreatedDate: data.PublishedDate || data.CreatedDate,
      Source: data.Source,
      AuthorName: data.ProfileName,
      Url: data.Url,
      Language: data.Language,
      contentDesc: data.contentDesc,
      Subjects: data.Subjects || [],
      availabilityCheckDate: data.availabilityCheckDate,
      IsRemoved: data.IsRemoved,
      Screenshots: data.Screenshots || []
    };

    const tagsData = data.tags || {};
    const tags = {
      EntityId: data.EntityId,
      PolicyViolation: tagsData.PolicyViolation,
      PolicyViolationTheme: tagsData.PolicyViolationTheme,
      PolicyViolationDescription: tagsData.PolicyViolationDescription,
      PostType: tagsData.PostType,
      AntisemitismTypes: tagsData.AntisemitismTypes
    };

    const hasData = (obj) => {
      return Object.values(obj).some(val =>
        val !== undefined &&
        val !== null &&
        val !== '' &&
        !(Array.isArray(val) && val.length === 0)
      );
    };

    return {
      entity,
      tags: hasData(tags) ? tags : null
    };
  } catch (error) {
    if (error.name === 'AbortError') {
      throw error;
    }
    throw new Error(`Failed to fetch entity data: ${error.message}`);
  }
};
